<template>
   <div class="graybox zoho_dashboard">
      <div id="app" v-if="!organization_id">
         <div class="container p-l-r-0 " style="background-color: #fff">
            <div class="col-md-12 col-sm-12 col-xs-12  dashboard_new_main zohodashboard">
               <div>
                  <h1 class="tbl-title leftpad">Please enter your Organization ID</h1>
                  <div class="balances-row">
                     <div class="col-md-12 col-sm-12 col-xs-12">
                        <div class="col-md-9 col-sm-9 col-xs-12">
                           <form @submit.prevent="getOrganizationID" class="Organization_id_form">
                              <input type="text" value="" class="form-control input-sm" name="organization_id" v-model="userData.organization_id">
                              <span class="text-danger" v-if="userData_errors.organization_id">{{this.userData_errors.organization_id}}</span>
                              <input type="button" @click="getOrganizationID()" value="Submit" class="btn btn-primary gobtn submit form-controlbtn">
                           </form>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div v-else>
         <div class="container p-l-r-0 " style="background-color: #fff">
            <div class="col-md-12 col-sm-12 col-xs-12  dashboard_new_main">
               <div>
                  <h3 class="text-left sub-head">Dashboard</h3>
                  <a @click="$router.go(-1)"  class="btn btn-primary save-summary gobtn call-btn">Back</a>
               </div>
               <div class="col-md-12 col-sm-12 col-xs-12 f-left dashboard_total_block">
                  <div  class=" col-md-6 f-left">
                     <div class="">
                        <h4>
                           Total Receivables 
                           <i id="ember1902" class="tooltip-container ember-view font-small">
                              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 512 512" xml:space="preserve" class="icon icon-xs text-muted cursor-pointer">
                                 <path d="M317.1 147.5c-15.1-13.8-35.5-20.8-60.5-20.8-23.7 0-43.1 6.5-57.7 19.4-14.6 12.9-23.5 31.5-26.4 55.5l-.6 4.9 40.4 4.8.7-4.6c2.5-15.8 7.7-27.5 15.4-34.7 7.7-7.2 17.1-10.7 28.7-10.7 12 0 21.9 3.9 30.1 11.9 8.2 8 12.2 16.9 12.2 27.3 0 5.6-1.3 10.7-4 15.4-2.8 4.9-9.3 11.9-19.3 20.7-10.7 9.4-17.9 16.5-22.1 21.5-5.8 7-10 14-12.6 20.8-3.5 9.1-5.3 19.9-5.3 32.3 0 2.1.1 5.1.2 9l.1 4.7h38.4l.1-4.8c.3-14.3 1.4-21.4 2.3-24.7 1.3-4.7 3.2-8.8 5.9-12.5 2.8-3.8 9-10 18.5-18.4 15.1-13.4 25.1-24.6 30.4-34.2 5.4-9.7 8.1-20.4 8.1-31.9 0-19.9-7.7-37-23-50.9zM256.3 385.3c12.1 0 22-9.8 22-22 0-12.1-9.8-22-22-22-12.1 0-22 9.8-22 22s9.8 22 22 22z"></path>
                                 <path d="M437.4 74.6C388.9 26.1 324.5-.5 256-.5S123.1 26.2 74.6 74.6C26.1 123.1-.5 187.5-.5 256s26.7 132.9 75.1 181.4c48.5 48.5 112.9 75.1 181.4 75.1s132.9-26.7 181.4-75.1c48.5-48.5 75.1-112.9 75.1-181.4s-26.6-132.9-75.1-181.4zm-22.6 340.2c-42.4 42.4-98.8 65.8-158.8 65.8s-116.4-23.4-158.8-65.8C54.8 372.4 31.5 316 31.5 256S54.8 139.6 97.2 97.2C139.6 54.8 196 31.5 256 31.5s116.4 23.4 158.8 65.8c42.4 42.4 65.8 98.8 65.8 158.8s-23.4 116.3-65.8 158.7z"></path>
                              </svg>
                           </i>
                        </h4>
                     </div>
                     <div class="balances-row">
                        <table class="table table-bordered">
                           <tbody>
                              <tr>
                                 <td colspan="2">
                                    <small class="text-muted">Total Unpaid Invoices ₹{{ receivables_un_paid }} </small> 
                                    <div class="progressbar">
                                       <div class="progerss_range" style="width:7%"></div>
                                    </div>
                                 </td>
                              </tr>
                              <tr>
                                 <td class="cursor-pointer" width="50%" data-ember-action="" data-ember-action-2181="2181">
                                    <div class="current-balance">
                                       <small class="text-open uppercase Current">Current</small> 
                                       <div class="legend over-flow" title="₹0.00">₹{{ receivables_current }}</div>
                                    </div>
                                 </td>
                                 <td>
                                    <div id="ember2182" class="popover-container ember-view">
                                       <div class="overdue-balance">
                                          <small class="text-overdue uppercase ">Overdue</small> 
                                          <div title="₹0.00">
                                             <div id="ember2183" class="ember-view legend cursor-pointer over-flow"> ₹{{ receivables_over_due }} 
                                             </div>
                                          </div>
                                       </div>
                                       <div id="ember2184" class="d-none popover bs-popover-bottom ember-view" style="inset: 100% auto auto; visibility: visible;">
                                          <!---->
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
                  <div  class="col-md-6 f-left">
                     <div class="">
                        <h4>
                           Total Payables 
                           <i id="ember1910" class="tooltip-container ember-view font-small">
                              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 512 512" xml:space="preserve" class="icon icon-xs text-muted cursor-pointer">
                                 <path d="M317.1 147.5c-15.1-13.8-35.5-20.8-60.5-20.8-23.7 0-43.1 6.5-57.7 19.4-14.6 12.9-23.5 31.5-26.4 55.5l-.6 4.9 40.4 4.8.7-4.6c2.5-15.8 7.7-27.5 15.4-34.7 7.7-7.2 17.1-10.7 28.7-10.7 12 0 21.9 3.9 30.1 11.9 8.2 8 12.2 16.9 12.2 27.3 0 5.6-1.3 10.7-4 15.4-2.8 4.9-9.3 11.9-19.3 20.7-10.7 9.4-17.9 16.5-22.1 21.5-5.8 7-10 14-12.6 20.8-3.5 9.1-5.3 19.9-5.3 32.3 0 2.1.1 5.1.2 9l.1 4.7h38.4l.1-4.8c.3-14.3 1.4-21.4 2.3-24.7 1.3-4.7 3.2-8.8 5.9-12.5 2.8-3.8 9-10 18.5-18.4 15.1-13.4 25.1-24.6 30.4-34.2 5.4-9.7 8.1-20.4 8.1-31.9 0-19.9-7.7-37-23-50.9zM256.3 385.3c12.1 0 22-9.8 22-22 0-12.1-9.8-22-22-22-12.1 0-22 9.8-22 22s9.8 22 22 22z"></path>
                                 <path d="M437.4 74.6C388.9 26.1 324.5-.5 256-.5S123.1 26.2 74.6 74.6C26.1 123.1-.5 187.5-.5 256s26.7 132.9 75.1 181.4c48.5 48.5 112.9 75.1 181.4 75.1s132.9-26.7 181.4-75.1c48.5-48.5 75.1-112.9 75.1-181.4s-26.6-132.9-75.1-181.4zm-22.6 340.2c-42.4 42.4-98.8 65.8-158.8 65.8s-116.4-23.4-158.8-65.8C54.8 372.4 31.5 316 31.5 256S54.8 139.6 97.2 97.2C139.6 54.8 196 31.5 256 31.5s116.4 23.4 158.8 65.8c42.4 42.4 65.8 98.8 65.8 158.8s-23.4 116.3-65.8 158.7z"></path>
                              </svg>
                           </i>
                        </h4>
                     </div>
                     <div class="balances-row">
                        <table class="table table-bordered">
                           <tbody>
                              <tr>
                                 <td colspan="2">
                                    <small class="text-muted">Total Unpaid Bills ₹{{ payables_un_paid }}</small> 
                                    <div class="progressbar">
                                       <div class="progerss_range"></div>
                                    </div>
                                 </td>
                              </tr>
                              <tr>
                                 <td class="cursor-pointer" width="50%" data-ember-action="" data-ember-action-2449="2449">
                                    <div class="current-balance">
                                       <small class="text-open Current uppercase">Current</small> 
                                       <div class="legend over-flow" title="₹0.00">₹ {{ payables_current }}</div>
                                    </div>
                                 </td>
                                 <td>
                                    <div id="ember2450" class="popover-container ember-view">
                                       <div class="overdue-balance">
                                          <small class="text-overdue uppercase">Overdue</small> 
                                          <div title="₹12,720.00">
                                             <div id="ember2451" class="ember-view legend cursor-pointer over-flow">
                                                ₹{{ payables_overdue }}
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
               </div>
               <div class="col-md-12 col-sm-12 col-xs-12 f-left dashboard_cashflow_block">
                  <div class="">
                     <h4>
                        Cash Flow
                        <i id="ember1902" class="tooltip-container ember-view font-small">
                           <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 512 512" xml:space="preserve" class="icon icon-xs text-muted cursor-pointer">
                              <path d="M317.1 147.5c-15.1-13.8-35.5-20.8-60.5-20.8-23.7 0-43.1 6.5-57.7 19.4-14.6 12.9-23.5 31.5-26.4 55.5l-.6 4.9 40.4 4.8.7-4.6c2.5-15.8 7.7-27.5 15.4-34.7 7.7-7.2 17.1-10.7 28.7-10.7 12 0 21.9 3.9 30.1 11.9 8.2 8 12.2 16.9 12.2 27.3 0 5.6-1.3 10.7-4 15.4-2.8 4.9-9.3 11.9-19.3 20.7-10.7 9.4-17.9 16.5-22.1 21.5-5.8 7-10 14-12.6 20.8-3.5 9.1-5.3 19.9-5.3 32.3 0 2.1.1 5.1.2 9l.1 4.7h38.4l.1-4.8c.3-14.3 1.4-21.4 2.3-24.7 1.3-4.7 3.2-8.8 5.9-12.5 2.8-3.8 9-10 18.5-18.4 15.1-13.4 25.1-24.6 30.4-34.2 5.4-9.7 8.1-20.4 8.1-31.9 0-19.9-7.7-37-23-50.9zM256.3 385.3c12.1 0 22-9.8 22-22 0-12.1-9.8-22-22-22-12.1 0-22 9.8-22 22s9.8 22 22 22z"></path>
                              <path d="M437.4 74.6C388.9 26.1 324.5-.5 256-.5S123.1 26.2 74.6 74.6C26.1 123.1-.5 187.5-.5 256s26.7 132.9 75.1 181.4c48.5 48.5 112.9 75.1 181.4 75.1s132.9-26.7 181.4-75.1c48.5-48.5 75.1-112.9 75.1-181.4s-26.6-132.9-75.1-181.4zm-22.6 340.2c-42.4 42.4-98.8 65.8-158.8 65.8s-116.4-23.4-158.8-65.8C54.8 372.4 31.5 316 31.5 256S54.8 139.6 97.2 97.2C139.6 54.8 196 31.5 256 31.5s116.4 23.4 158.8 65.8c42.4 42.4 65.8 98.8 65.8 158.8s-23.4 116.3-65.8 158.7z"></path>
                           </svg>
                        </i>
                     </h4>
                     <div  class="dropdown dropdown-view  clearfix list-title">
                        <a  class="dropdown-toggle  no-caret" @click="toggle">
                           <!----> This Fiscal Year 
                        </a>
                        <ul v-show="!shown">
                           <li><a href="#">This Fiscal Year</a></li>
                           <li><a href="#">Previous Fiscal Year</a></li>
                           <li><a href="#">Last 12 Months</a></li>
                        </ul>
                     </div>
                  </div>
                  <div class="balances-row">
                     <div class="col-md-12 col-sm-12 col-xs-12 f-left cashflow_box">
                        <div class="col-md-9 col-sm-9 col-xs-12 f-left cashflow_graph">
                           <VueApexCharts  ref="cashflow" type="line" :options="chartOptions" :series="series"></VueApexCharts>
                        </div>
                        <div class="col-md-3 col-sm-3 col-xs-12 f-left cashflow_content">
                           <div class="cashflow-value-row">
                              <div class="cursor-pointer" data-ember-action="" data-ember-action-2457="2457">
                                 <div class="text-muted">Cash as on {{cash_flow_date}}</div>
                                 <div class="legend over-flow direction-ltr">₹{{cash_flow_op_balance}}</div>
                              </div>
                           </div>
                           <div class="cashflow-value-row">
                              <div>
                                 <div class="text-moneyin">Incoming</div>
                                 <div class="legend over-flow direction-ltr">₹{{cash_flow_debit_amout_total}}</div>
                              </div>
                              <div class="signs"> + </div>
                           </div>
                           <div class="cashflow-value-row">
                              <div>
                                 <div class="text-moneyout">Outgoing</div>
                                 <div class="legend over-flow direction-ltr">₹{{cash_flow_credit_amount}}</div>
                              </div>
                              <div class="signs"> - </div>
                           </div>
                           <div class="cashflow-value-row">
                              <div class="cursor-pointer" data-ember-action="" data-ember-action-2458="2458">
                                 <div class="text-open">Cash as on {{cash_flow_end_date}}</div>
                                 <div class="legend over-flow direction-ltr">₹{{cash_flow_ending_balance}}</div>
                              </div>
                              <div class="signs"> = </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-md-12 col-sm-12 col-xs-12 f-left dashboard_expense_block">
                  <div  class=" col-md-6 f-left">
                     <div class="incom_expanse_box">
                        <div class="box_heading">
                           <h4>
                              Income and Expense 
                              <i id="ember1902" class="tooltip-container ember-view font-small">
                                 <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 512 512" xml:space="preserve" class="icon icon-xs text-muted cursor-pointer">
                                    <path d="M317.1 147.5c-15.1-13.8-35.5-20.8-60.5-20.8-23.7 0-43.1 6.5-57.7 19.4-14.6 12.9-23.5 31.5-26.4 55.5l-.6 4.9 40.4 4.8.7-4.6c2.5-15.8 7.7-27.5 15.4-34.7 7.7-7.2 17.1-10.7 28.7-10.7 12 0 21.9 3.9 30.1 11.9 8.2 8 12.2 16.9 12.2 27.3 0 5.6-1.3 10.7-4 15.4-2.8 4.9-9.3 11.9-19.3 20.7-10.7 9.4-17.9 16.5-22.1 21.5-5.8 7-10 14-12.6 20.8-3.5 9.1-5.3 19.9-5.3 32.3 0 2.1.1 5.1.2 9l.1 4.7h38.4l.1-4.8c.3-14.3 1.4-21.4 2.3-24.7 1.3-4.7 3.2-8.8 5.9-12.5 2.8-3.8 9-10 18.5-18.4 15.1-13.4 25.1-24.6 30.4-34.2 5.4-9.7 8.1-20.4 8.1-31.9 0-19.9-7.7-37-23-50.9zM256.3 385.3c12.1 0 22-9.8 22-22 0-12.1-9.8-22-22-22-12.1 0-22 9.8-22 22s9.8 22 22 22z"></path>
                                    <path d="M437.4 74.6C388.9 26.1 324.5-.5 256-.5S123.1 26.2 74.6 74.6C26.1 123.1-.5 187.5-.5 256s26.7 132.9 75.1 181.4c48.5 48.5 112.9 75.1 181.4 75.1s132.9-26.7 181.4-75.1c48.5-48.5 75.1-112.9 75.1-181.4s-26.6-132.9-75.1-181.4zm-22.6 340.2c-42.4 42.4-98.8 65.8-158.8 65.8s-116.4-23.4-158.8-65.8C54.8 372.4 31.5 316 31.5 256S54.8 139.6 97.2 97.2C139.6 54.8 196 31.5 256 31.5s116.4 23.4 158.8 65.8c42.4 42.4 65.8 98.8 65.8 158.8s-23.4 116.3-65.8 158.7z"></path>
                                 </svg>
                              </i>
                           </h4>
                           <div  class="dropdown dropdown-view  clearfix list-title">
                              <a  class="dropdown-toggle  no-caret" @click="toggle_income">
                              Previous Fiscal Year
                              </a>
                              <ul v-show="!shown_income">
                                 <li><a href="#">This Fiscal Year</a></li>
                                 <li><a href="#">Previous Fiscal Year</a></li>
                                 <li><a href="#">Last 12 Months</a></li>
                                 <li><a href="#">Last 6 Months</a></li>
                              </ul>
                           </div>
                        </div>
                        <div class="balances-row box-pad">
                           <div class="incom_expense_grapgh">
                           <VueApexCharts  ref="income_expense" type="bar" :options="income_chartOptions" :series="income_series"></VueApexCharts>
                           </div>
                           <div class="box_details row">
                              <div class="col-md-3">
                                 <div width="98" id="ember2460" class="zec-container ember-view">
                                    <svg width="100%" height="40" viewBox="0 0 98 40" preserveAspectRatio="xMidYMid meet">
                                       <g class="legends-container" transform="translate(1,5)">
                                          <g class="legend-container" transform="translate(0,0)">
                                             <text class="font-small" x="30" y="12">Income</text>
                                             <rect y="4.655339241027832" width="25" height="7" rx="0" style="fill: rgb(169, 212, 125);"></rect>
                                          </g>
                                          <g class="legend-container" transform="translate(0,20)">
                                             <text class="font-small" x="30" y="12">Expense</text>
                                             <rect y="4.655339241027832" width="25" height="7" rx="0" style="fill: #e4585a"></rect>
                                          </g>
                                       </g>
                                    </svg>
                                 </div>
                              </div>
                              <div class="col-md-5" style="border-left: 1px solid #ededed;">
                                 <div>
                                    <div class="font-small text-moneyin">Total Income</div>
                                    <div class="legend over-flow direction-ltr" title="₹0.00">₹{{income_total}}</div>
                                 </div>
                              </div>
                              <div class="col-md-4 p-0">
                                 <div>
                                    <div class="font-small text-moneyout">Total Expenses</div>
                                    <div class="legend over-flow direction-ltr" title="₹0.00">₹{{ expense_total }}</div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div  class="col-md-6 f-left">
                     <div class="incom_expanse_box">
                        <div class="box_heading">
                           <h4>
                              Your Top Expenses 
                              <i id="ember1910" class="tooltip-container ember-view font-small">
                                 <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 512 512" xml:space="preserve" class="icon icon-xs text-muted cursor-pointer">
                                    <path d="M317.1 147.5c-15.1-13.8-35.5-20.8-60.5-20.8-23.7 0-43.1 6.5-57.7 19.4-14.6 12.9-23.5 31.5-26.4 55.5l-.6 4.9 40.4 4.8.7-4.6c2.5-15.8 7.7-27.5 15.4-34.7 7.7-7.2 17.1-10.7 28.7-10.7 12 0 21.9 3.9 30.1 11.9 8.2 8 12.2 16.9 12.2 27.3 0 5.6-1.3 10.7-4 15.4-2.8 4.9-9.3 11.9-19.3 20.7-10.7 9.4-17.9 16.5-22.1 21.5-5.8 7-10 14-12.6 20.8-3.5 9.1-5.3 19.9-5.3 32.3 0 2.1.1 5.1.2 9l.1 4.7h38.4l.1-4.8c.3-14.3 1.4-21.4 2.3-24.7 1.3-4.7 3.2-8.8 5.9-12.5 2.8-3.8 9-10 18.5-18.4 15.1-13.4 25.1-24.6 30.4-34.2 5.4-9.7 8.1-20.4 8.1-31.9 0-19.9-7.7-37-23-50.9zM256.3 385.3c12.1 0 22-9.8 22-22 0-12.1-9.8-22-22-22-12.1 0-22 9.8-22 22s9.8 22 22 22z"></path>
                                    <path d="M437.4 74.6C388.9 26.1 324.5-.5 256-.5S123.1 26.2 74.6 74.6C26.1 123.1-.5 187.5-.5 256s26.7 132.9 75.1 181.4c48.5 48.5 112.9 75.1 181.4 75.1s132.9-26.7 181.4-75.1c48.5-48.5 75.1-112.9 75.1-181.4s-26.6-132.9-75.1-181.4zm-22.6 340.2c-42.4 42.4-98.8 65.8-158.8 65.8s-116.4-23.4-158.8-65.8C54.8 372.4 31.5 316 31.5 256S54.8 139.6 97.2 97.2C139.6 54.8 196 31.5 256 31.5s116.4 23.4 158.8 65.8c42.4 42.4 65.8 98.8 65.8 158.8s-23.4 116.3-65.8 158.7z"></path>
                                 </svg>
                              </i>
                           </h4>
                           <div  class="dropdown dropdown-view  clearfix list-title">
                              <a  class="dropdown-toggle  no-caret" @click="toggle_expence">
                                 <!----> This Fiscal Year 
                              </a>
                              <ul v-show="!shown_expence">
                                 <li><a>This Fiscal Year</a></li>
                                 <li><a>This Quarter</a></li>
                                 <li><a>This Month</a></li>
                                 <li><a>Previous Fiscal Year</a></li>
                                 <li><a>Previous Quarter</a></li>
                                 <li><a>Previous Month</a></li>
                                 <li><a>Last 6 Months</a></li>
                                 <li><a>Last 12 Months</a></li>
                              </ul>
                           </div>
                        </div>
                        <div class="balances-row">
                           <VueApexCharts  ref="expense_ch" type="pie" :options="income_chartOptions" :series="income_series"></VueApexCharts>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
   import VueApexCharts from 'vue-apexcharts'
   import activityService from "../services/activity"
   import Zoho from '../services/zoho'
   export default {
       name:'zoho-dashboard',
       props: ['subscription'],
        watch: {
            subscription: {
               handler(val){
                  this.GetworkspaceData(val)
               },
               deep: true,
               immediate: true
            }
         },
       data() {
           return {
               userData:{
                  organization_id :'',
                  unique_id:''
               },
               userData_errors:{
                  organization_id:''
               },
               summary: [],
               summary_preset:false,
               organization_id:'',
               masterSubscription:{},
               shown: true,
               shown_income: true,
               shown_expence: true,
               cash_flow_date:0,
               cash_flow_op_balance:0,
               cash_flow_debit_amout_total:0,
               cash_flow_credit_amount:0,
               cash_flow_end_date:0,
               cash_flow_ending_balance:0,
               income_total:0,
               expense_total:0,
               receivables_un_paid:'00.00',
               receivables_current:'00.00',
               receivables_over_due:'00.00',
               payables_un_paid : '00.00',
               payables_current : '00.00',
               payables_overdue : '00.00',
                 income_series: [{
            name: 'Servings',
            data: [44, 55, 41, 67, 22, 43, 21, 33, 45, 31, 87, 65, 35]
          }],
          income_chartOptions: {
            annotations: {
              points: [{
                x: 'Bananas',
                seriesIndex: 0,
                label: {
                  borderColor: '#775DD0',
                  offsetY: 0,
                  style: {
                    color: '#fff',
                    background: '#775DD0',
                  },
                  text: 'Bananas are good',
                }
              }]
            },
            chart: {
              height: 350,
              type: 'bar',
            },
            plotOptions: {
              bar: {
                borderRadius: 10,
                columnWidth: '50%',
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              width: 2
            },
            
            grid: {
              row: {
                colors: ['#fff', '#f2f2f2']
              }
            },
            xaxis: {
              labels: {
                rotate: -45
              },
              categories: ['Apples', 'Oranges', 'Strawberries', 'Pineapples', 'Mangoes', 'Bananas',
                'Blackberries', 'Pears', 'Watermelons', 'Cherries', 'Pomegranates', 'Tangerines', 'Papayas'
              ],
              tickPlacement: 'on'
            },
            yaxis: {
              title: {
                text: 'Servings',
              },
            },
            fill: {
              type: 'gradient',
              gradient: {
                shade: 'light',
                type: "horizontal",
                shadeIntensity: 0.25,
                gradientToColors: undefined,
                inverseColors: true,
                opacityFrom: 0.85,
                opacityTo: 0.85,
                stops: [50, 0, 100]
              },
            }
          },
               chartOptions: {
                  chart: {
                     id: 'vuechart-example-income',
                  },
                  xaxis: {
                     categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998,1998,1998,1998,1998,1998,1998],
                  },
               },
               series: [{
                  data: [30, 40, 45, 50, 49, 60, 70, 81]
               }]
           }
      },
      components: {
         VueApexCharts
      },
       methods: {
          GetworkspaceData(data){
            activityService.postActivity(data)
            .then(response=>{
               this.masterSubscription = response.data;
               if(this.masterSubscription){
                  this.organization_id = this.masterSubscription.data.organization_id;
                  this.userData.unique_id = this.masterSubscription.data.unique_id;
                  this.userData.organization_id = this.masterSubscription.data.organization_id;
                  if(this.organization_id){
                     this.getReceivables();
                  }
               }
            })
            
        },
           toggle() {
             this.shown = !this.shown;
   
           },
           toggle_income() {
             this.shown_income = !this.shown_income;
   
           },
           toggle_expence() {
             this.shown_expence = !this.shown_expence;
   
           },
           getReceivables(){
               Zoho.receivables(this.userData)
                           .then(response=>{
                               if(response.data.status == "fail"){
                                 this.userData_errors.organization_id = response.data.message
                                 this.$notify({
                                             group: 'auth',
                                             title: '',
                                             type: 'warn',
                                             text: this.userData_errors.organization_id,
                                             ignoreDuplicates: true
                                          });
                                    setTimeout(() => 
                                       this.userData_errors.organization_id = ''
                                    ,4000)
                                    this.organization_id = '';
                                 this.userData.organization_id = '';
                                    return;
                              }
                              if(response.data.status == "success"){
                                 this.receivables_un_paid = response.data.data.ar_unpaid;
                                 this.receivables_current = response.data.data.ar_current;
                                 this.receivables_over_due = response.data.data.ar_over_flow;
                                 this.payables_un_paid = response.data.data.ap_unpaid;
                                 this.payables_current = response.data.data.ap_current;
                                 this.payables_overdue = response.data.data.ap_over_flow;
                                 this.cash_flow_date   = response.data.data.cash_flow_date
                                 this.cash_flow_op_balance   = response.data.data.cash_flow_op_balance
                                 this.cash_flow_debit_amout_total   = response.data.data.cash_flow_debit_amout_total
                                 this.cash_flow_credit_amount   = response.data.data.cash_flow_credit_amount
                                 this.cash_flow_end_date   = response.data.data.cash_flow_end_date
                                 this.cash_flow_ending_balance   = response.data.data.cash_flow_ending_balance
                                 this.income_total   = response.data.data.income_s_total
                                 this.expense_total   = response.data.data.expense_s_total
                                 this.$refs.cashflow.updateSeries([{
                                    data:response.data.data.cash_flow,
                                    }], false, true);
                                 this.$refs.income_expense.updateSeries([{
                                    data:response.data.data.income,
                                    }], false, true);
                                 this.$refs.expense_ch.updateSeries([{
                                    data:response.data.data.expenses,
                                    }], false, true);      
                                 
                                 
                              }
                           })
                           .catch(error=>{
                              console.log(error)
                              return
                           })
               
           },
           getOrganizationID(){
              if(!this.userData.organization_id){
                 this.userData_errors.organization_id = "Please fill required field"
                 this.$notify({
                            group: 'auth',
                            title: '',
                            type: 'warn',
                            text: 'Please fill required fields',
                            ignoreDuplicates: true
                        });
                  setTimeout(() => 
                     this.userData_errors.organization_id = ''
                  ,4000)
                  return;
              }
              Zoho.updateOrganizationID(this.userData)
                           .then(response=>{
                              if(response.data.status == "fail"){
                                 this.userData_errors.organization_id = response.data.message
                                 this.$notify({
                                             group: 'auth',
                                             title: '',
                                             type: 'warn',
                                             text: this.userData_errors.organization_id,
                                             ignoreDuplicates: true
                                          });
                                    setTimeout(() => 
                                       this.userData_errors.organization_id = ''
                                    ,4000)
                                    return;
                              }
                              if(response.data.status == "success"){
                                 this.organization_id = response.data.data.organization_id;
                                 this.userData.organization_id = response.data.data.organization_id;
                              }
                              
                           })
                           .catch(error=>{
                              console.log(error)
                              return
                           })


           }
       }
   }
   
</script>
<style  scoped>
   @import './../../assets/css/dashboard_zoho.css';
</style>